exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3[data-v-9b172b08]{margin:40px 0 0}ul[data-v-9b172b08]{list-style-type:none;padding:0}li[data-v-9b172b08]{display:inline-block;margin:0 10px}a[data-v-9b172b08]{color:#42b983}", ""]);

// exports
